export interface Word {
  startTime: number;
  endTime: number;
  content: string;
  edited?: boolean;
  speaker?: string;
  channel?: number;
}

export default class TranscriptWord implements Word {
  public startTime: number;
  public endTime: number;
  public content: string;
  public edited?: boolean;
  public speaker?: string;

  public constructor(content: string, startTime: number, endTime: number, speaker: string | undefined, edited: boolean = false) {
    this.content = content;
    this.startTime = startTime;
    this.endTime = endTime;
    this.speaker = speaker;
    this.edited = edited;
  }
}
